import { BomItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { BomItemPointer } from '../../../../model/Project/BomItemPointer'
import { bomItemSelector } from './bomItemSelector'

export const bomItemFileNameSelector =
  (bomItemPointer: BomItemPointer) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemPointer)

    if (!bomItem) {
      return null
    }

    if (
      bomItem?.type === BomItemType.materialHeader ||
      bomItem?.type === BomItemType.routingHeader ||
      bomItem?.type === BomItemType.project
    ) {
      return null
    }

    return bomItem?.type === BomItemType.assemblyType
      ? bomItem.originalFileName
      : bomItem.originalFileName || ''
  }
